module.exports = __webpack_public_path__ + "static/img/pexels-jeshootscom-442580.2783e857.png";